import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authApi } from '../services/api';

export default function MsalCallbackPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const msError = params.get('error');
    const msErrorDescription = params.get('error_description');

    if (msError) {
      setError(msErrorDescription || msError);
      return;
    }

    if (!code) {
      setError('No authorization code received from Microsoft.');
      return;
    }

    const codeVerifier = localStorage.getItem('pkce_verifier') || '';
    localStorage.removeItem('pkce_verifier');

    authApi.microsoftToken(code, codeVerifier)
      .then(({ data }) => {
        login(data.access_token, data.role, data.full_name);
        navigate('/dashboard', { replace: true });
      })
      .catch((err: any) => {
        const detail = err.response?.data?.detail;
        const status = err.response?.status;
        const code = err?.code;
        if (detail) {
          setError(detail);
        } else if (code === 'ERR_NETWORK' || !status) {
          setError('Cannot reach the server. Check your connection and try again.');
        } else {
          setError(`Sign-in failed (HTTP ${status}). Please try again.`);
        }
      });
  }, []);

  if (error) {
    return (
      <div className="min-h-screen dark:bg-gsw-navy bg-gray-100 flex items-center justify-center p-4 transition-colors duration-200">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
          <div className="h-[3px]" style={{ background: 'linear-gradient(90deg, #C9A84C, #E8C97A, #C9A84C)' }} />
          <div className="p-10 text-center">
            <img src="/gsw_logo.png" alt="GSW" className="h-12 mx-auto mb-6 object-contain" />
            <p className="text-red-600 text-sm font-medium mb-4">{error}</p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              className="text-sm text-gsw-navy underline hover:no-underline"
            >
              Back to sign in
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen dark:bg-gsw-navy bg-gray-100 flex items-center justify-center transition-colors duration-200">
      <div className="dark:text-white/60 text-gray-400 text-sm">Signing you in…</div>
    </div>
  );
}
